"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TabCarouselSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intentsConfig = _interopRequireDefault(require("../../../page-body/media-components/tab-carousel-section/intents.config.js"));
var _tabCarouselItem = _interopRequireDefault(require("./tab-carousel-item"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TabCarouselSectionContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "TabCarouselSectionContainer",
  class: "pl-tzqjgsr",
  vars: {
    "tzqjgsr-0": [({
      verticalMargin
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalMargin, true)],
    "tzqjgsr-3": [({
      verticalMargin
    }) => (0, _patternLibraryUtils.getVerticalSpace)(verticalMargin)]
  }
});
const TabsContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "TabsContainer",
  class: "pl-t7juxy5",
  vars: {
    "t7juxy5-0": [({
      tabsCount
    }) => tabsCount]
  }
});
const Tab = /*#__PURE__*/(0, _react2.styled)("button")({
  name: "Tab",
  class: "pl-t1in0waf",
  vars: {
    "t1in0waf-0": [({
      active
    }) => active ? `${_intentsConfig.default.uxTabs.itemChosen.foregroundColor}` : `${_intentsConfig.default.uxTabs.item.foregroundColor}`],
    "t1in0waf-1": [({
      active
    }) => active ? `var(--active-tab-border-width) ${_intentsConfig.default.ux.figure.figureColor0}` : `var(--inactive-tab-border-width) ${_intentsConfig.default.ux.box.borderColor}`],
    "t1in0waf-2": [({
      active
    }) => active ? '2.25rem' : 'calc(2.25rem + (var(--active-tab-border-width) - var(--inactive-tab-border-width)))']
  }
});
const FeatureContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FeatureContainer",
  class: "pl-fsb26l6"
});

/**
 * TabCarouselSection Component
 * @module TabCarouselSection
 *
 * @param {object} props React props
 * @param {string} props.eyebrow Eyebrow text
 * @param {heading} props.heading Heading text
 * @param {node} props.description Description
 * @param {array} props.items Array of Tab Carousel Items
 * @param {boolean} props.slideAnimation True to use slide animation, false to use fade in
 * @param {string} props.verticalMargin vertical outer spacing
 * @returns {React.ReactElement} TabCarouselSection Component
 * @public
 */
function TabCarouselSection({
  eyebrow,
  heading,
  description,
  items,
  slideAnimation = false,
  verticalMargin = 'none'
}) {
  const [activeTabIndex, setActiveTabIndex] = (0, _react.useState)(0);
  return /*#__PURE__*/_react.default.createElement(TabCarouselSectionContainer, {
    "data-cy": "tab-carousel-section",
    verticalMargin: verticalMargin
  }, /*#__PURE__*/_react.default.createElement(_index.default, {
    eyebrow: eyebrow,
    heading: heading,
    description: description,
    textAlign: "center",
    headlineTag: "h2",
    headlineLineLength: 2.25
  }), /*#__PURE__*/_react.default.createElement(TabsContainer, {
    role: "tablist",
    tabsCount: items.length
  }, items && items.map(({
    tabTitle,
    ariaLabel
  }, i) => /*#__PURE__*/_react.default.createElement(Tab, (0, _extends2.default)({
    key: i,
    role: "tab",
    "aria-label": ariaLabel || tabTitle,
    "data-cy": "tab",
    active: i === activeTabIndex,
    onClick: () => setActiveTabIndex(i)
  }, _patternLibraryUtils.tracking.create(`${tabTitle}-tab`, true, true)), tabTitle))), /*#__PURE__*/_react.default.createElement(FeatureContainer, null, items?.map((item, i) => /*#__PURE__*/_react.default.createElement(_tabCarouselItem.default, (0, _extends2.default)({
    key: i,
    active: i === activeTabIndex,
    slideAnimation: slideAnimation
  }, item)))));
}
TabCarouselSection.propTypes = {
  eyebrow: _propTypes.default.string,
  heading: _propTypes.default.string,
  description: _propTypes.default.node,
  items: _propTypes.default.arrayOf(_propTypes.default.shape(_tabCarouselItem.default.propTypes)),
  slideAnimation: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps
};